import { render, staticRenderFns } from "./local-volume-sheet.vue?vue&type=template&id=2f59722c&scoped=true&"
import script from "./local-volume-sheet.vue?vue&type=script&lang=js&"
export * from "./local-volume-sheet.vue?vue&type=script&lang=js&"
import style0 from "./local-volume-sheet.vue?vue&type=style&index=0&id=2f59722c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f59722c",
  null
  
)

export default component.exports